module.exports = __webpack_public_path__ + "static/not_available-6be7ce81dae839805f89060aff5bd57c.png";